import * as React from 'react'
import * as css from './ImageWithCaption.module.css'
import imageUrlBuilder from '@sanity/image-url'
import clsx from 'clsx'

const height = 400

export default function ImageWithCaption({
	image,
	imageMobile,
	alt,
	caption,
	className,
	config,
}) {
	if (!image) return null

	const src = imageUrlBuilder(config)
		.image(image)
		.height(height)
		.fit('max')
		.auto('format')
		.url()

	const { w, h } = getDimensions(src)

	return (
		<picture className={clsx('block', className)}>
			{imageMobile && <Source image={imageMobile} config={config} />}

			<img
				src={src}
				alt={alt || ''}
				width={h >= height ? parseInt((w / h) * 400) : w}
				height={h >= height ? height : h}
				loading="lazy"
			/>
			{caption && <figcaption className={css.caption}>{caption}</figcaption>}
		</picture>
	)
}

function Source({ image, config }) {
	if (!image) return null

	const src = imageUrlBuilder(config).image(image).auto('format').url()

	const { w, h } = getDimensions(src)

	return <source srcSet={src} media="(max-width: 768px)" width={w} height={h} />
}

function getDimensions(src) {
	const { w, h } = src.match(
		/-(?<w>\d+)x(?<h>\d+)\.(jpg|jpeg|png|gif|webp|svg)/,
	).groups

	return { w, h }
}
